import type {
  CencoFee,
  CreditFee
} from '../../interfaces/src/bff-web/billing/interfaces/payment-methods.interfaceV2';
import { notifyError } from '../../services/error-handler';

import type { TFees, TTransformedFees } from './interfaces';

export const transformFees = (fees: TFees[]): TTransformedFees[] => {
  if (!fees) return [];

  return fees.map((fee) => ({
    name: fee?.fee === 0 ? 'Sin cuotas' : `${fee?.fee} Cuotas`,
    value: String(fee?.fee)
  }));
};

export const addDefaultFee = (fees: TFees[]) => {
  if (!fees) return [];
  fees.unshift({ fee: 1 });
  return fees;
};

export const getTransformedFees = (
  fees?: CencoFee[] | CreditFee[]
): TTransformedFees[] => {
  try {
    let feesArray: TFees[] = fees ? Object.values(fees) : [];
    // TODO: the fees API response should include this base value
    feesArray = addDefaultFee(feesArray);
    return transformFees(feesArray);
  } catch (error) {
    notifyError(error);
    return [];
  }
};
